import { Dispatch, SetStateAction, useState } from "react";
import { Alert, Collapse } from "reactstrap";
import { SelectPicker } from "rsuite";

import { ReusableViewReferenceFields } from "../../../../types/PageInterfaces";
import { LinkSettings } from "../ReusableViewSettings";

function ReusableViewWithMultipleSoruces({
  fieldSubViewLink,
  viewsLoading,
  isGlobalTenant,
  setPickerOpened,
  reusableViewRefereceField,
  onChange,
  appName,
  hasFetched,
}: {
  fieldSubViewLink: LinkSettings;
  viewsLoading: boolean;
  isGlobalTenant: boolean;
  setPickerOpened: Dispatch<SetStateAction<boolean>>;
  reusableViewRefereceField: ReusableViewReferenceFields | undefined;
  onChange: (
    val: string | null,
    type: "Module" | "Field",
    apiName: string,
    moduleAPIName: string
  ) => void;
  appName: string;
  hasFetched: boolean;
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className="tw:pb-2">
      <div className="tw:flex tw:border tw:border-lighter tw:rounded-t-sm tw:py-2">
        <div
          className={`tw:flex tw:items-center tw:cursor-pointer`}
          onClick={() => setOpen((prev) => !prev)}
        >
          <i
            className={`mdi mdi-chevron-${
              open ? "down" : "right"
            } text-dark px-2`}
            style={{ fontSize: 20 }}
          />
          <h4 className="tw:m-0">{fieldSubViewLink.Name}</h4>
        </div>
      </div>
      <Collapse isOpen={open}>
        <div className="tw:border tw:border-lighter tw:rounded-t-sm tw:cursor-pointer tw:py-2 tw:mb-0 tw:px-2">
          {!!fieldSubViewLink.IsSubitem ? (
            <>
              {fieldSubViewLink?.Fields.map((f) => {
                return (
                  <ReusableViewWithMultipleSoruces
                    key={f.APIName}
                    fieldSubViewLink={f}
                    viewsLoading={viewsLoading}
                    isGlobalTenant={isGlobalTenant}
                    setPickerOpened={setPickerOpened}
                    reusableViewRefereceField={reusableViewRefereceField}
                    onChange={onChange}
                    appName={appName}
                    hasFetched={hasFetched}
                  />
                );
              })}
            </>
          ) : (
            <>
              {fieldSubViewLink.ModuleViews.map((mv) => {
                return (
                  <>
                    <div className="tw:flex tw:justify-around tw:items-center tw:pb-3">
                      <h4 className="tw:m-0">{mv.ModuleAPIName}:</h4>
                      <div className="tw:w-xs">
                        <SelectPicker
                          disabled={
                            !isGlobalTenant ||
                            (hasFetched && !mv?.Views?.length)
                          }
                          block
                          size="sm"
                          preventOverflow
                          placeholder={`Select a View to reuse it.`}
                          searchable={!!mv?.Views?.length}
                          onOpen={() => setPickerOpened(true)}
                          value={
                            reusableViewRefereceField?.[
                              fieldSubViewLink?.APIName
                            ]?.[mv.ModuleAPIName]
                          }
                          onChange={(val) => {
                            onChange(
                              val,
                              fieldSubViewLink.Type,
                              fieldSubViewLink.APIName,
                              mv.ModuleAPIName
                            );
                          }}
                          data={mv.Views}
                          loading={viewsLoading}
                          labelKey={"PageViewName"}
                          valueKey={"_id"}
                          style={{ width: "100%" }}
                          onClean={() =>
                            onChange(
                              null,
                              fieldSubViewLink.Type,
                              fieldSubViewLink.APIName,
                              mv.ModuleAPIName
                            )
                          }
                        />
                      </div>
                    </div>
                    {hasFetched && !mv?.Views?.length && (
                      <div className="tw:w-full tw:px-8 tw:-mt-1 tw:mb-1">
                        <Alert
                          color="warning"
                          className="tw:py-1 tw:px-4 tw:mb-0 tw:font-medium"
                        >
                          No Views are using this Data Source{" "}
                          {appName ? `in ${appName}.` : ""}
                        </Alert>
                      </div>
                    )}
                  </>
                );
              })}
            </>
          )}
        </div>
      </Collapse>
    </div>
  );
}

export default ReusableViewWithMultipleSoruces;
